import React from 'react';
import PlaceholderPage from '../../components/ui/PlaceholderPage';

const SettingsPage: React.FC = () => {
  return (
    <PlaceholderPage 
      title="Settings"
      description="Configure your account and application preferences."
    />
  );
};

export default SettingsPage;
